import React from 'react'
import {
    SearchkitComponent,
    Accessor,
    FilterBucket,
    SumMetric,
} from 'searchkit'

class SumAggregationFilterAccessor extends Accessor {
    constructor(field) {
        super()
        this.field = field
    }

    buildOwnQuery = query =>
        query.setAggs(
            FilterBucket(
                this.field,
                query.getFilters(),
                SumMetric('total', this.field),
            ),
        )
}

export default class SumAggregationFilter extends SearchkitComponent {
    defineAccessor() {
        const { field } = this.props
        return new SumAggregationFilterAccessor(field)
    }

    render() {
        return <div />
    }
}
